import React, { useState } from 'react';
import "./header.css"; // Add your styles or use Bootstrap
import { Link } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
const Header = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [mobileMenuIcon, setMobileMenuIcon] = useState("bi-list");

  const toggleMenu = () => {
    setMobileMenu(!mobileMenu);
    setMobileMenuIcon(mobileMenu ? "bi-list" : "bi-x");
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <header id="header" className="header d-flex align-items-center fixed-top app-bg">
      <div className="container-fluid container-xl position-relative d-flex align-items-center">
        <a href="/#home" className="logo d-flex align-items-center me-auto">
          <h1 className="sitename">Gantasoft</h1>
          <span>.</span>
        </a>

        <nav id="navmenu" className="navmenu">
          <ul>
          <li><a href="/#home" className="active">Home</a></li>
          <li><a href="/#featured-services" >Services</a></li>
          <li><a href="/#projects" >Our Projects</a></li>
          <li><a href="/#about" >About</a></li>
          <li><a href="/#contact" >Contact Us</a></li>
          <li><Link to="technical-support" >Technical Support</Link></li>

            {/* <li><a href="#home" className="active">Home</a></li>
            <li><a href="#featured-services">Services</a></li>
            <li><a href="#projects"> Our Projects</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#contact">Contact Us</a></li>
            <li><a href="#">Technical Support</a></li> */}
          </ul>
          {/* <i className={`mobile-nav-toggle d-xl-none bi ${mobileMenuIcon}`} onClick={toggleMenu}></i> */}
        </nav>
        <i className="mobile-nav-toggle d-xl-none bi bi-list" onClick={handleShow}></i>
        <a className="btn-getstarted" href="/#contact">Get Started</a>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Menu</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ul className="modal-menu">
            <li><a href="/#home" className="active" onClick={handleClose}>Home</a></li>
          <li><a href="/#featured-services" onClick={handleClose}>Services</a></li>
          <li><a href="/#projects" onClick={handleClose}>Our Projects</a></li>
          <li><a href="/#about"onClick={handleClose} >About</a></li>
          <li><a href="/#contact" onClick={handleClose}>Contact Us</a></li>
          <li><Link to="/technical-support" onClick={handleClose}>Technical Support</Link></li>
             
            </ul>
          </Modal.Body>
        </Modal>
      </div>
    </header>
  );
}

export default Header;
